import { render, staticRenderFns } from "./HeaderCaret.vue?vue&type=template&id=4fa2bb42&"
import script from "./HeaderCaret.vue?vue&type=script&lang=js&"
export * from "./HeaderCaret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports